import Nav from "../../general/nav.jsx";
import HeroFooter from "../../general/heroFooter.jsx";
import Imghero from "../../../assets/img/projects/LosPistoleros/Los_Pistoleros-Hero.png";
import ImgheroMobile from "../../../assets/img/projects/LosPistoleros/Los_Pistoleros-hero-mobile.png";
import Logo from "../../../assets/img/projects/LosPistoleros/Los_Pistoleros-Logo.png";
import { useTranslation } from "react-i18next";
import { useState, useLayoutEffect } from "react";

function Hero() {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useLayoutEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const heroStyle = {
    backgroundImage: `url(${isMobile ? ImgheroMobile : Imghero})`,
  };

  return (
    <div className="LosPistoleros hero" id="hero" style={heroStyle}>
      <Nav />
      <img className="ImgHero" src={Logo} alt="Los Pistoleros Logo" />
      <HeroFooter
        name={t("losPistoleros.hero.name")}
        link1url="https://los-pistoleros.com/"
        link2display={false}
        link2name={t("losPistoleros.hero.link2")}
        link2url="https://www.instagram.com/lospistolerosofficiel/?hl=fr"
      />
    </div>
  );
}

export default Hero;
